<template>
    <div>

        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol col="8" style="text-align: start ;padding:0 20px 0 20px ">
                                <strong>{{$t('buyReport')}}</strong>
                            </CCol>
                            <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">
                                <CButton @click="get_lists" color="dark"
                                         size="sm">
                                    <CIcon size="sm" name="cil-zoom"/>
                                </CButton>
                                <CButton
                                        class="mr-1"
                                        size="sm"
                                        @click="print_with_header_title_height(body_id,header_id,'print_report_footer',selected_person_name,200,200)"
                                        color="secondary"
                                >{{ $t("buttons.print") }}
                                </CButton>
                            </CCol>

                        </CRow>
                    </CCardHeader>
                    <br>
                    <CRow>

                        <CCol col="3">
                            <treeselect
                                    v-model="selected_person"
                                    :options="person_async_list"
                                    :normalizer="normalizer_persons"
                                    :async="sync_person"
                                    @select="select_user"
                                    :loadOptions="load_persons"
                                    :placeholder="$t('searchSupplier')"
                            />
                        </CCol>
                        <CCol col="3">
                            <date-picker
                                    :label="$t('components.startDate')"
                                    v-model="start_date"></date-picker>
                        </CCol>
                        <CCol col="3">
                            <date-picker
                                    :label="$t('components.endDate')"
                                    v-model="end_date"></date-picker>
                        </CCol>
                    </CRow>
                    <CCardBody :id="body_id">
                        <!--                        <ReportGrid :fields="fields" :items="items_customer"/>-->
                        <CDataTableFixed
                                :items="items_customer"
                                :fields="fields"
                                :items-per-page="10"
                                hover
                                border
                                :height="get_pagination? '60vh' : ''"

                                :responsive="true"
                                striped
                        >
                            <template #row_id="{item,index}">

                                <td>
                                    <p style="text-align: center">{{ index+1 }}</p>

                                </td>

                            </template>
                            <template #docDate="{item}">
                                <td :style="get_style(item)">
                                    <p v-if="item.personAccountId!=0" style="text-align: center">{{ get_date(item.docDate) }}</p>
                                    <p v-else></p>
                                </td>
                            </template>
                            <template #amount="{item}">
                                <td :style="get_style(item)+'text-align:right'">
                                    <p style="text-align:right">{{ get_currency(item.amount) }}</p>
                                </td>
                            </template>

                            <template #amountNegetive="{item}">
                                <td :style="get_style(item)+'text-align:right'">
                                    <p style="text-align:right">{{ get_currency(item.amountNegetive) }}</p>
                                </td>
                            </template>

                            <template #accBalanceNegetive="{item}">
                                <td :style="get_style(item)+'text-align:right'">
                                    <p>{{ get_currency(item.accBalanceNegetive) }}</p>
                                </td>
                            </template>
                            <template #kardexAccTypeTitle="{item}">
                                <td :style="get_style(item)">
                                    <p v-if="item.personAccountId==0" style="text-align: end">{{ item.statusTitle }}</p>
                                    <p v-else>{{ item.statusTitle }}</p>
                                </td>
                            </template>

                            <template #masterId="{item}">
                                <td style="text-align: center" :style="get_style(item)">
                                    <a v-if="item.personAccountId!=0 && item.statusId<=8" href="javascript:void(0)" class="text-primary"
                                       v-on:click="goToDocuments(item)">
                                        {{ item.masterCode }}
                                    </a>
<!--                                    <a v-if="item.personAccountId!=0 && item.statusId>8" href="javascript:void(0)" class="text-primary"-->
<!--                                       v-on:click="goToAccDoc(item)">-->
<!--                                        {{ item.payDocCode }}-->
<!--                                    </a>-->
                                  <a v-if="item.payDocCode!=null" href="javascript:void(0)" class="text-primary"
                                     v-on:click="goToAccDoc(item)">
                                    - {{ item.payDocCode }}
                                  </a>

                                  <a v-if="item.accNo!=null" href="javascript:void(0)" class="text-primary"
                                     v-on:click="goToAccountingDoc(item)">
                                    - {{ item.accNo }}
                                  </a>
                                </td>

                            </template>
                            <template #summary="{item}">
                                <td>
                                    <p v-if="item.summary != 'null'">{{ item.summary }}</p>
                                </td>

                            </template>
                            <template #accBalance="{item}">
                                <td>
                                    <p style="text-align:right"  v-if="item.accBalance<=0">{{ get_currency(Math.abs(item.accBalance)) }}</p>
                                    <p style="text-align:right" class="text-danger" v-else>{{ get_currency(item.accBalance) }}</p>
                                </td>
                            </template>
                            <template #caption>
                                <tr class="total-table">
                                  <td>{{$t('totalCirculation')}}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{get_currency(get_sum_debtor(items_customer))}}</td>
                                    <td>{{get_currency(get_sum_credetor(items_customer))}}</td>
                                  <td class="" v-if="(parseFloat(items_customer.filter(x=>x.personAccountId==0)[0].accBalance)
                                        -get_sum_credetor(items_customer)+get_sum_debtor(items_customer))<0">

                                    {{get_currency(Math.abs(parseFloat(items_customer.filter(x=>x.personAccountId==0)[0].accBalance)
                                      -get_sum_credetor(items_customer)+get_sum_debtor(items_customer))) }}
                                  </td>

                                  <td class="text-danger" v-else>
                                    {{get_currency(parseFloat(items_customer.filter(x=>x.personAccountId==0)[0].accBalance)
                                      -get_sum_credetor(items_customer)+get_sum_debtor(items_customer)) }}
                                  </td>

                                </tr>


                            </template>

                        </CDataTableFixed>

                    </CCardBody>
                    <div v-show="false">
                        <div :id="header_id"  style="margin-right: 50px;margin-left: 50px;margin-bottom: 30px">
                            <CCol>
                                <CRow style="justify-content:center">
                                    <strong style="font-size: large">{{get_bussiness_name()}}</strong>
                                </CRow>

                                <CRow style="justify-content:center">
                                    {{selected_person_name}}
                                </CRow>
                                <CRow>
                                    <CCol >
                                        <label>{{$t('FromDate')}} {{get_date(start_date)}}</label>
                                    </CCol>
                                    <CCol style="text-align:center" >
                                        <label >{{$t('UpToDate')}} {{get_date(end_date)}}</label>
                                    </CCol>
                                    <CCol style="text-align:end" >
                                        <label >{{$t('PreparedDate')}} {{get_date(get_today())}}</label>
                                    </CCol>
                                </CRow>

                            </CCol>

                        </div>
                        <div id="print_report_footer" class="border-dark">
                            <CCardHeader>
                                <CRow style="border: 1px solid #000">
                                    <CCol sm="4" md="4" style="text-align: start">
                                        <h2>{{$t('docCreator')}} : {{ get_user_name() }}</h2>
                                    </CCol>
                                    <CCol sm="4" md="4" style="text-align: center">
                                        <h2 id="pageFooter" class="pageFooter"></h2>
                                    </CCol>
                                    <CCol sm="4" md="4" style="text-align: end">
                                        <h2>
                                            {{get_filter(types_parent,'value',selected_type_parent,'reportCode')}}
                                        </h2>
                                    </CCol>
                                </CRow>

                            </CCardHeader>

                        </div>

                    </div>


                </CCard>
            </CCol>
        </CRow>
        <CModal
                :show.sync="show_factor_detail"
                :no-close-on-backdrop="true"
                :centered="true"
                :title="$t('InventoryBill')"
                size="lg"
                color="dark"
        >
            <CCard id="printMe">
                <ShowPayReceiveDocs :doc_id="selected_doc_id"/>

            </CCard>


            <template #footer>

                <CButton
                        @click="show_factor_detail = false"
                        color="success"
                >{{ $t("buttons.close") }}
                </CButton>
            </template>
        </CModal>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'

    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import ShowPayReceiveDocs from "../accounting/ShowPayReceiveDocs";

    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
    export default {
        name: 'Login',
        components: {
            Treeselect,
            ShowPayReceiveDocs,
        },
        data() {
            return {
                body_id:'print_report_buy_one_supplier',
                header_id:'print_header_buy_one_supplier',
                selected_doc_id: null,
                show_factor_detail: false,

                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                VUE_APP_Currency: localStorage.getItem('currency'),
                items_customer: [],
                start_date: '',
                end_date: '',

                types_all: [],
                types_parent: [],
                selected_type_parent: 11,
                selected_type_child: 0,

                fields: [//amount amountNegetive accBalance accBalanceNegetive
                    {key: 'row_id', label: this.$t('tables.row'), sorter: false, _style: 'width:5%'},
                    {key: 'docDate', label: this.$t('date'), _style: 'width:10%'},

                    {key: 'kardexAccTypeTitle', label: this.$t('documentType'), _style: 'width:10%'},
                    {key: 'masterId', label: this.$t('reference'), _style: 'width:10%'},

                    {key: 'amountNegetive', label: this.$t('tables.debtor'), _style: 'width:10%'},
                    {key: 'amount', label: this.$t('tables.creditor'), _style: 'width:10%'},
                    {key: 'accBalance', label: this.$t('tables.balance'), _style: 'width:10%'},

                    // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},

                ],
                normalizer_accounting(node) {
                    return {
                        id: node.id,
                        label: node.accountCode + " " + node.accountName,
                    }
                },
                normalizer_accounting_tafzili(node) {
                    return {
                        id: node.recId,
                        label: node.title,
                    }
                },
                load_persons({action, searchQuery, callback}) {

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);
                            var url = "GetAllPersons";

                            formData.append('IsVendor', true);
                            formData.append('IsWorker', false);
                            formData.append('IsCustomer', false);
                            formData.append('IsActive', 0);

                            axios.post(url, formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                            })
                                .catch(function (error) {

                                });

                        })
                    }
                },
                normalizer_persons(node) {
                    return {
                        id: node.userId,
                        label: node.personCode + " " + node.fullName,
                    }
                },
                templates_items: [],
                accounting_list: [],
                moein_list: [],
                tafsili_list: [],
                selected_person: null,
                selected_moein: null,
                selected_tafsili: null,
                collapseDuration: 0,
                person_name: '',
                status_form: 0,
                tafsiliTypeId: 0,
                person_async_list: [],
                sync_person: true,
                selected_person_name: '',

            }
        }, mounted() {

            this.$root.root_validate_errors = [];
            this.get_lists_groups();
            this.get_types();

            // this.get_lists();
            this.start_date = this.get_day_before_today(1);
            this.end_date = this.get_today();

            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
            if(this.$route.params.personId!=null){
                this.selected_type_parent = 11;
                this.sync_person = false;
                this.person_async_list = [{
                    userId: this.$route.params.personId,
                    personCode: this.$route.params.personCode,
                    tafsiliTypeId: this.$route.params.tafsiliTypeId,
                    fullName: this.$route.params.personName
                }];

                setTimeout(() => {
                    this.selected_person = this.$route.params.personId;
                    this.tafsiliTypeId = this.$route.params.tafsiliTypeId;
                    this.get_lists();
                }, 300);
                setTimeout(() => {
                    this.sync_person = true;
                }, 1000);
                this.start_date = this.$route.params.start_date;
                this.end_date = this.$route.params.end_date;
            }

            bus.$on("report_select_one_supplier", (data) => {
                this.selected_type_parent = 11;
                this.sync_person = false;
                this.person_async_list = [{
                    userId: data.item.personId,
                    personCode: data.item.personCode,
                    tafsiliTypeId: data.item.tafsiliTypeId,
                    fullName: data.item.personName + " " + data.item.surName
                }];

                setTimeout(() => {
                    this.selected_person = data.item.personId;
                    this.tafsiliTypeId = data.item.tafsiliTypeId;
                    this.get_lists();
                }, 300);
                setTimeout(() => {
                    this.sync_person = true;
                }, 1000);
                this.start_date = data.start_date;
                this.end_date = data.end_date;
            });

        }, watch: {
            'selected_tafsili': function () {
                // this.get_lists();
            }
        },
        methods: {
            select_user(node, instance) {
                this.selected_person_name = node.fullName + " " + node.personCode;

            },
            get_style(item) {
                var color = '#56ff42';
                if (item.personAccountId == 0) {
                    // return 'backgroundColor: \'#56ff42\'';
                    return {
                        backgroundColor: color
                    }
                }
            },
            get_sum_debtor(list) {
                var sum = 0;
                list.forEach((val) => {
                    sum += parseFloat(val.amountNegetive);
                })
                return sum;
            },
            get_sum_credetor(list) {
                var sum = 0;
                list.forEach((val) => {
                    sum += parseFloat(val.amount);
                })
                return sum;
            },
            edit_item(item) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = item.unitName;
                this.color = item.color;
                this.description = item.description;
                this.previewImage = item.image;
                this.status_form = item.id;
            },
            emptyList() {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = '';
                this.color = '';
                this.description = '';
                this.previewImage = '';
                this.status_form = 0;

                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            }, edit_sale_method(item) {
                this.selected_method = item.saleMethodId;
                this.selected_person = item.userId;
                this.saleMethodModal = true;

            },
            select_moein(node) {
                var self = this;

                const formData = new FormData();
                var url = "GetAccountTafsiliList";
                formData.append("id", node.id);

                // self.tafzili_list = [];

                axios.post(url, formData, {}).then(function (response) {

                        var content_data = response.data;

                        if (content_data.statusCode == 0) {

                            // item.tafzili_list = response.data.data;
                            self.tafsili_list = response.data.data
                        } else {
                            self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                        }

                    }
                ).catch(function (error) {
                    console.log(error);
                });

            },
            get_lists_groups() {

                var self = this;
                self.items_parent = [];
                self.data_with_children = []

                const formData = new FormData();
                var url = "Get_AllAccountingGroups";

                axios.post(url, formData, {}).then(function (response) {

                        var content_data = response.data;

                        if (content_data.statusCode == 0) {

                            self.accounting_list = response.data.data
                            response.data.data.forEach((val) => {
                                if (val.parentId == 0) {

                                    self.get_childrens_one_sub(val.id, self.accounting_list).forEach((val2) => {

                                        self.get_childrens_one_sub(val2.id, self.accounting_list).forEach((val3) => {

                                            self.moein_list.push(val3)

                                        });

                                    });

                                }

                            });
                        } else {
                            self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                        }

                    }
                )
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            get_childrens_one_sub(parent_id, list) {
                var array = [];
                var self = this;
                list.forEach((val2) => {

                    if (parent_id == val2.parentId) {
                        // var obj = {label: val2.accountCode + " " + val2.accountName, value: val2.id, code: val2.accountCode}
                        array.push(val2);


                    }
                });
                return array;
            },
            get_lists() {
                var self = this;


                const formData = new FormData();

                var url = "GetPersonAccountsByPersonId_New";
//tasiliType 0 =>Other, 1=> Personal, 2=> Customers, 3=> Sellers, 4=> Persons, 5=> Bank,, 6=> CashBox,

                // formData.append('TafsiliType', this.tafsiliTypeId);
                formData.append('TafsiliType', 3);
                formData.append('id', this.selected_person);
                formData.append('PartyId', this.selected_person);
                formData.append('ParentId', this.selected_type_parent);
                formData.append('ChildId', this.selected_type_child);
                formData.append('FromDate', this.start_date);
                formData.append('ToDate', this.end_date);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;
                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.items_customer = content_data.data.personAccountItems;

                        self.items_customer.forEach(function (val,index) {
                            if(index==0) {
                                val.reminingBefore = 0;
                                if(val.natureId==0 && self.items_customer[index+1]!=null){
                                    val.natureId = self.items_customer[index+1].natureId;
                                }
                                // val.accBalance = val.accBalance
                            }else{
                                val.reminingBefore = self.items_customer[index-1].accBalance;

                                if(val.natureId==2){
                                    val.accBalance = parseFloat(val.reminingBefore) +  parseFloat(val.amount);
                                    // val.accBalanceFinal =val.accBalance
                                    if(val.amount>0){
                                        val.amountNegetive=Math.abs(val.amount);
                                        val.amount=0;

                                    }else{
                                        val.amount=Math.abs(val.amount);
                                        val.amountNegetive=0;
                                    }
                                }else{

                                    val.accBalance = parseFloat(val.reminingBefore)   + parseFloat(val.amount);
                                    if(val.amount<0){
                                        val.amountNegetive=0;
                                        val.amount=Math.abs(val.amount);

                                    }else{
                                        val.amountNegetive=Math.abs(val.amount);
                                        val.amount=0;

                                    }
                                }
                            }

                        })

// for(var i=0;i<200;i++){
//     self.items_customer.push(self.items_customer[0])
// }

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            goEditPerson(item) {

                this.$router.push({path: '/dashboard/users/edit-user/' + item.userId});

            },
            goToDocuments(item) {

                // if (item.statusId >= 1 && item.statusId <= 6) {
                // this.$router.push({path: '/dashboard/documents/show/' + item.masterId});
                window.open('/dashboard/documents/show/' + item.masterId)

                // }

                // if (item.statusId == 8 || item.statusId == 7) {
                //     //receive cash
                //     this.selected_doc_id = item.masterId
                //
                //     this.show_factor_detail = true
                //     // this.$router.push({path: '/dashboard/documents/show/' + item.masterId});
                // }
            },
            goToAccDoc(item) {


                this.selected_doc_id = item.payDocId
                //
                this.show_factor_detail = true
                //     // this.$router.push({path: '/dashboard/documents/show/' + item.masterId});
                // }
            },
          goToAccountingDoc(item) {
            window.open('/dashboard/accounting/show-accounting-doc/'+item.payAccId)
          },
            delete_item_dialog(item) {
                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

                this.status_form = item.id;

            }, delete_item() {


                let self = this;
                const formData = new FormData()
                let url;
                url = "DeletePerson";


                formData.append('id', this.status_form);

                axios.post(url, formData, {}).then((res) => {
                    self.$root.modal_component.show_api_response_modals(res);

                    self.status_form = 0;

                    self.get_lists();

                })
                    .catch(function (error) {

                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            get_types() {
                var self = this;


                const formData = new FormData();

                var url = "GetReportNumberList";

                // formData.append('id', "1532");
                //
                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;
                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        var data_get = self.sort_array([], content_data.data
                            , "id", "title");
                        self.types_all = data_get.filter(x => x.typeId == 4);
                        self.types_parent = data_get.filter(x => x.parentId == 0 && x.typeId == 4);
                        self.selected_type_parent = self.types_parent[0].value;
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_child_options() {
                var array = [{label: this.$t('select'), value: 0}];
                var newArray = array.concat(this.types_all.filter(x => x.parentId == this.selected_type_parent));
                return newArray
            }

        }
    }

</script>
<style>
    .height-2000 {
        height: 300px !important;
    }
</style>
